import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class OneToManyService {

  // fer gato
  // public agregadoOneToMany: BehaviorSubject<any> = new BehaviorSubject<any>(null)
  // public editadoOneToMany: BehaviorSubject<any> = new BehaviorSubject<any>(null)
  // public eliminadoOneToMany: BehaviorSubject<any> = new BehaviorSubject<any>(null)

  //es ideal que al agregar un item a cada mapa le pongamos un key que no se repita porque puede pinchar
  //el key es el "field.name" del generic form
  //por ejemplo en crud siniestro, al field one to many de "detalles" 
  //le puse "crud-siniestro-detalles" para asegurarme de que no se repita
  public agregadoOneToMany = new Map<string, BehaviorSubject<any>>();
  public editadoOneToMany = new Map<string, BehaviorSubject<any>>();
  public eliminadoOneToMany = new Map<string, BehaviorSubject<any>>();
}
